import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./lib/LanguageContext";
import { CartProvider } from "./lib/CartContext";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { FloatingCart } from "./components/FloatingCart";
import { CartSheet } from "./components/CartSheet";
import Home from "./pages/Home";
import Menu from "./pages/Menu";
import "./App.css";

function App() {
  return (
    <LanguageProvider>
      <CartProvider>
        <BrowserRouter>
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/menu" element={<Menu />} />
            <Route path="*" element={<Home />} />
          </Routes>
          <Footer />
          <FloatingCart />
          <CartSheet />
        </BrowserRouter>
      </CartProvider>
    </LanguageProvider>
  );
}

export default App;
